export const MCP_CAPABILITY_OPTIONS = [
  { id: 'keyword_tracker', label: 'ردیاب کلمات' },
  { id: 'keyword_research', label: 'تحقیق کلمات' },
  { id: 'content', label: 'محتوا' },
  { id: 'bugs', label: 'باگ‌ها' }
] as const;

export const STATUS_LABELS: Record<string, string> = {
  draft: 'پیش‌نویس',
  pending: 'در انتظار تایید',
  approved: 'تایید شده',
  rejected: 'رد شده',
  archived: 'بایگانی'
};

export const VISIBILITY_LABELS: Record<string, string> = {
  private: 'خصوصی',
  public: 'عمومی'
};
